import { createAction, props } from '@ngrx/store';
import { Correspondence, SentCorrespondences, Templates } from './sent-correspondence.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records sent correspondences',
    props<{ id: string }>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records sent correspondences success', 
    props<{ listData: SentCorrespondences[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records sent correspondences failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record correspondence',
    props<{id: string, dossierId: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record correspondence success', 
    props<{ singleData: any }>()
);

export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record correspondence failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state sent correspondences',
);